/**
 * Somebody filled the stock. There is no record of with what, or of why.
 */

import type { Affix } from '@/sim/items/affixContract';

export const DEAD_WEIGHT = {
  id: 'deadWeight',
  slot: 'suffix',
  field: 'handling',
  direction: 1,
  label: 'Slower to aim',
  nameWord: 'of Dead Weight',
  ranges: {
    common: { min: 0.05, max: 0.09 },
    uncommon: { min: 0.08, max: 0.14 },
    rare: { min: 0.12, max: 0.19 },
    exotic: { min: 0.16, max: 0.25 },
  },
} as const satisfies Affix;
